import { IRootState } from '../../../store'
import { ISingleSelectPageState } from '../store/singleSelectPage.types'

export const getSingleSelectPageSelector = (state: IRootState): ISingleSelectPageState => state.singleSelectPage
